module.exports = __webpack_public_path__ + "static/media/logo-dark-en.bd629335.svg";